/* globals google */
'use strict';
var map;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
async function maps() {
    var infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(37.09024, -95.712891);
    var mapOptions = {
        scrollwheel: false,
        zoom: 15,
        center: latlng
    };

    var mapCanvas = $('.map-canvas')[0];

    if ($('.modal .map-canvas').length === 1) {
        mapCanvas = $('.modal .map-canvas')[0];
    }

    map = new google.maps.Map(mapCanvas, mapOptions);
    var mapdiv = $('.map-canvas').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    var markerImg = $('.map-canvas').attr('data-marker-image');

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);

        map.setCenter(new google.maps.LatLng(item.latitude, item.longitude));

        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: markerImg
        });

        marker.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(map, marker);
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').removeClass('d-none');
        $('.map-container').addClass('d-none');
    } else {
        $('.store-locator-no-results').addClass('d-none');
        $('.map-container').removeClass('d-none');
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');
    var urlParams = { radius: radius };

    var payload = $form.is('form') ? $form.serialize() : { postalCode: $form.find('[name="postalCode"]').val() };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        }
    });
    return false;
}


/**
 * Search for stores with new zip code
 * @param {Object} suggestResult - suggest result from google
 * @param {Object} geometryObject - geometry object from google
 */
function searchStores(suggestResult, geometryObject) {
    var pointsList = $('.js-points-list');
    var spinner = pointsList.length ? pointsList.spinner() : $.spinner();
    var geometry = suggestResult.geometry || geometryObject;
    var countryCode = suggestResult.countryCode || suggestResult.address_components[suggestResult.address_components.length - 1].short_name;
    spinner.start();

    var input = $('#store-postal-code');

    $('.js-storelocator-postcode-error').html('');
    var addressComponents = $('.store-page').data('components');

    var endpointUrl = appendToUrl(input.data('storesFindUrl'), {
        lat: geometry.location.lat(),
        long: geometry.location.lng(),
        showMap: true,
        radius: input.data('storesSearchRadius'),
        countryCode: countryCode,
        addressComponents: addressComponents
    });

    $.ajax({
        url: endpointUrl,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        }
    });
}

/**
 * @description Show geolocation error
 * @param {string} type type of error
 */
function showGeolocatorError(type) {
    var errorBlock = $('.js-storelocator-postcode-error');
    errorBlock.html(errorBlock.data(type));
}

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            let initGoogleHandlers = require('../common/googleEvents');
            var $target;
            if ($('#store-postal-code').length > 0) {
                $target = $('#store-postal-code');
            } else {
                $target = $('#ups-google-api');
            }
            initGoogleHandlers($target, {
                isSkipAddingEvents: true,
                errorField: $('js-storelocator-postcode-error'),
                myLocationBtn: $('.detect-location'),
                handleAddress: searchStores,
                showGeolocatorError: showGeolocatorError
            }).then(() => {
                maps();
            });
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').addClass('d-none');
            $('.map-container').addClass('d-none');
        }

        if ($('input[name="store"]').is(':checked')) {
            $('.select-store').prop('disabled', false);
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.results').data('radius');
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                    }
                });
            });
        });
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            search($(this));
        });

        $(document).on('click', '.btn-storelocator-search[type="button"]', function (e) {
            e.preventDefault();
            search($(this));
        });

        $(document).on('keypress', '.store-page-inp', function (e) {
            if (e.keyCode === 13) {
                search($('.btn-storelocator-search'));
            }
        });
    },

    changeRadius: function () {
        $('.store-locator-container .radius').change(function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data('search-key');
            var url = $(this).data('action-url');
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long
                };
            }

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                }
            });
        });
    },
    selectStore: function () {
        $(document).on('click', '.select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },
    showStoreOnMap: function () {
        $(document).on('click', '.select-store-input', (function () {
            var store = $('#' + this.id);
            var storeName = store.data('store-info').name;

            $('div[title^="' + storeName + '"]').click();
        }));
    },
    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));
    },
    updateUpsSelectStoreButton: function () {
        $('body').on('change', '.ups-select-store-input', (function () {
            $('.ups-select-store').prop('disabled', false);
        }));
    },
    selectUpsStore: function () {
        $(document).on('click', '.ups-select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .ups-results');
            var data = {
                storeID: selectedStore.val(),
                storeInfo: JSON.stringify(selectedStore.data('store-info')),
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };
            $('body').trigger('upsStore:selected', data);
        }));
    },
    upsStoreResult: function () {
        $('body').on('ups:update', function (e, data) {
            var $resultsDiv = $('.ups-results');
            var $mapDiv = $('.ups-store-pickup').find('.map-canvas');
            var hasResults = data.accessPointsArray.stores.stores.length > 0;

            if (!hasResults) {
                $('.store-locator-no-results').removeClass('d-none');
                $('.ups-store-pickup').find('.map-container').addClass('d-none');
            } else {
                $('.store-locator-no-results').addClass('d-none');
                $('.ups-store-pickup').find('.map-container').removeClass('d-none');
            }

            $mapDiv.attr('data-locations', data.accessPointsArray.locations);

            if ($mapDiv.data('has-google-api')) {
                setTimeout(function () {
                    maps();
                }, 200);
            } else {
                $('.ups-store-pickup').find('.store-locator-no-apiKey').show();
            }

            if (data.accessPointsArray.storesResultsHtml) {
                $resultsDiv.empty().append(data.accessPointsArray.storesResultsHtml);
            }
        });
    }
};
